import { request } from '@fastlessjs/backoffice-layer/dist/hooks/stores/helpers';
import { useMutation } from '@tanstack/react-query';

export type RefreshPayload = {
  entity: 'enterprise' | 'order' | 'suivi' | 'product';
  items?: Array<Record<string, unknown>>;
  filter?: Record<string, unknown>;
};

export type RefreshResult =
  | {
      eurekaOk: true;
      changed: boolean;
      data: object;
      [key: string]: unknown;
    }
  | {
      eurekaOk: false;
      error: string;
      [key: string]: unknown;
    }
  | {
      skipped: true;
      reason: 'too_recent';
      data: object;
      [key: string]: unknown;
    };

export type RefreshResponse = {
  entity: string;
  refreshedAt: string;
  results: RefreshResult[];
};

export async function postRefresh(payload: RefreshPayload): Promise<RefreshResponse> {
  const result = await request('/refresh/', {
    method: 'post',
    options: { body: payload },
  });
  return result as RefreshResponse;
}

export function useRefreshEntity() {
  return useMutation({
    mutationFn: postRefresh,
  });
}
